import { useTranslation } from "react-i18next";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { SubscriptionsApi } from "../../../../../../../services/Api/Subscription/subscriptionTypes";

interface Props {
	estimatedLoan: SubscriptionsApi;
}

const SubscriptionsTableSimple = (props: Props) => {
	const { estimatedLoan } = props;
	const { t } = useTranslation();

	return (
		<>
			<table className={"table table-preview"}>
				<thead>
					<tr>
						<th>{t("modules.loan.field.loan_and_license.title")}</th>
						<th>{t("modules.loan.field.expense.title")}</th>
					</tr>
				</thead>
				<tbody>
					{estimatedLoan.subscriptions.map((subscription) => {
						return (
							<>
								<tr>
									<td>{subscription.name}</td>
									<td>{FormatMoney(subscription.subscription_money)}</td>
								</tr>
								{subscription.addons.map((addon) => {
									return (
										<tr key={addon.addon_id}>
											<td>
												{addon.quantity} x {addon.name}
											</td>
											<td>{FormatMoney(addon.total_price)}</td>
										</tr>
									);
								})}
							</>
						);
					})}
					<tr>
						<td>
							<strong>{t("modules.loan.field.sum.title")}</strong>
						</td>
						<td>
							<strong>{FormatMoney(estimatedLoan.total_money)}</strong>
						</td>
					</tr>
				</tbody>
			</table>
		</>
	);
};
export default SubscriptionsTableSimple;
